import { render, staticRenderFns } from "./AccessruleDetails.vue?vue&type=template&id=42ff8386&scoped=true"
import script from "./AccessruleDetails.vue?vue&type=script&lang=js"
export * from "./AccessruleDetails.vue?vue&type=script&lang=js"
import style0 from "./AccessruleDetails.vue?vue&type=style&index=0&id=42ff8386&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42ff8386",
  null
  
)

export default component.exports